export var easing150Duration = "150ms";
export var easing150X1 = 0.25;
export var easing150Y1 = 0.1;
export var easing150X2 = 0.25;
export var easing150Y2 = 1;
export var easing250Duration = "250ms";
export var easing250X1 = 0.25;
export var easing250Y1 = 0.1;
export var easing250X2 = 0.25;
export var easing250Y2 = 1;
export var springFirmTension = 200;
export var springFirmFriction = 20;
export var springFirmMass = 0.5;
export var springFirmVelocity = 2;
export var framerTightType = "spring";
export var framerTightDamping = 15;
export var framerTightMass = 0.4;
export var framerTightStiffness = 300;
export var framerTightVelocity = 5;
export var framerFirmType = "spring";
export var framerFirmDamping = 10;
export var framerFirmMass = 0.5;
export var framerFirmStiffness = 200;
export var framerFirmVelocity = 2;